import { ActionModel, StandardThunkAction } from 'types';
import { Action, actionCreator } from 'util/actions';
import { createReducer } from 'util/reducers';

import {
  CLEAR_HIGHLIGHT_ACTIONS,
  LOAD_HIGHLIGHT_ACTIONS_SUCCESS,
  LoadHighlightActionsSuccessAction,
} from 'modules/loaders';

interface HighlightActionsState {
  [key: string]: ActionModel;
}

export interface HighlightsState {
  visibleActions: HighlightActionsState;
  idHighlights: string[];
}

const SET_HIGHLIGHTS = Symbol('ui/SET_HIGHLIGHTS');

type SetHighlightsAction = Action<typeof SET_HIGHLIGHTS, HighlightActionsState>;

const setHighlights = actionCreator<SetHighlightsAction>(SET_HIGHLIGHTS);

const initialState: HighlightsState = {
  visibleActions: {},
  idHighlights: [],
};

export default createReducer(initialState, {
  [SET_HIGHLIGHTS](state, { payload }: SetHighlightsAction) {
    return { ...state, visibleActions: payload };
  },

  [LOAD_HIGHLIGHT_ACTIONS_SUCCESS](
    state,
    { payload }: LoadHighlightActionsSuccessAction,
  ) {
    const idHighlights = payload.map((action) => action.id);
    const idHighlightsSet = new Set(idHighlights);

    return {
      ...state,
      idHighlights: [
        ...idHighlights,
        ...state.idHighlights.filter(
          (idHighlight) => !idHighlightsSet.has(idHighlight),
        ),
      ],
    };
  },

  [CLEAR_HIGHLIGHT_ACTIONS](state) {
    return initialState;
  },
});

export const updateHighlights = (): StandardThunkAction<void> => {
  return (dispatch, getState) => {
    dispatch(
      setHighlights(
        getState().models.actions.reduce(
          (acc: HighlightActionsState, action) => {
            acc[action.id] = action;

            return acc;
          },
          {},
        ),
      ),
    );
  };
};



// WEBPACK FOOTER //
// ./app/gamma/src/modules/state/models/highlights.ts